module.exports = __webpack_public_path__ + "img/64_2.bce86063.png";